<template>
  <div class="table-space main-table-scrollbar">
    <table class="table table-striped table-hover main-table">
      <thead>
        <tr>
          <!-- Add table headers here -->
          <!-- The table sort is triggered by click on the header -->
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyId')"
            >
              {{ lang.AM2000 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyId', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyId', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyName')"
            >
              {{ lang.AM2001 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyName', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyName', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyAddress')"
            >
              {{ lang.AM2002 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyAddress', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyAddress', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyAddress2')"
            >
              {{ lang.AM2007 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyAddress2', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyAddress2', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyCity')"
            >
              {{ lang.AM2003 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyCity', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyCity', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyState_Region')"
            >
              {{ lang.AM2004 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyState_Region', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyState_Region', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyPostalCode')"
            >
              {{ lang.AM2005 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyPostalCode', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyPostalCode', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencyCountry')"
            >
              {{ lang.AM2006 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencyCountry', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencyCountry', false)"
              ></span>
            </a>
          </th>
          <th class="text-center sticky-header">
            <a
              class="table-header"
              role="button"
              @click="orderTableCell('AgencySinceDate')"
            >
              {{ lang.AM2008 }}
              <span
                class="glyphicon glyphicon-triangle-top"
                v-if="showSortArrow('AgencySinceDate', true)"
              ></span>
              <span
                class="glyphicon glyphicon-triangle-bottom"
                v-if="showSortArrow('AgencySinceDate', false)"
              ></span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Doubleclick on the table row opens the edit dialog, singleclick selects the client -->
        <tr
          role="button"
          v-for="agency in pagedAgencies"
          :key="agency.AgencyId"
          @click="selectAgency(agency)"
          @dblclick="openEditAgency(agency)"
          :class="{
            info: agency.AgencyGuid === selectedAgency.AgencyGuid,
            'text-bold': agency.AgencyTypeName === 'Lead',
          }"
        >
          <!-- Add table data here -->
          <td>{{ agency.AgencyId }}</td>
          <td>{{ agency.AgencyName }}</td>
          <td>{{ agency.AgencyAddress }}</td>
          <td>{{ agency.AgencyAddress2 }}</td>
          <td>{{ agency.AgencyCity }}</td>
          <td>{{ agency.RegionCode }}</td>
          <td>{{ agency.AgencyPostalCode }}</td>
          <td>{{ agency.AgencyCountry }}</td>
          <td>{{ agency.AgencySince }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["tableFilter", "pageSize", "pageNumber", "selectedAgency"],
  name: "AgencyManagementTable",
  data() {
    return {
      lang: {
        AM2000: "ID",
        AM2001: "Name",
        AM2002: "Straße",
        AM2003: "Stadt",
        AM2004: "Region",
        AM2005: "PLZ",
        AM2006: "Land",
        AM2007: "Adresszusatz",
        AM2008: "Agentur seit",
      },
      allAgencies: [],
      filteredAgencies: [],
      pagedAgencies: [],
      currentSort: { key: "AgencyId", asc: true },
    };
  },
  // Manage Lifecycle Hooks
  created() {
    this.getAllAgencies();
  },
  mounted() {
    this.setClientTableHeight();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    // Sets the new table height after the window got resized
    $(window)
      .on("resize", () => {
        this.setClientTableHeight();
      })
      .resize();
  },
  // Methods
  methods: {
    // Common methods
    handleHttpError(err, text) {
      console.error(
        `An error occured while fetching data from Back end
        ${text ? text : ""}`,
        err
      );
    },
    extractHttpData(response) {
      if (response.status === 200) {
        // When server respondet with OK - 200
        return response.body;
      } else {
        this.handleHttpError(null, response.statusText);
      }
    },
    setRefreshEnabled(value) {
      this.$emit("onRefreshEnabled", value);
    },
    // Special methods
    getAllAgencies() {
      this.setRefreshEnabled(false);

      $.ajax({
        method: "GET",
        url: "api/agencies",
        success: (res) => {
          if (_.isEmpty(res)) res = [];
          this.allAgencies = res;
          this.$emit("agenciesReceived", this.allAgencies);
          this.filteredAgencies = res;
          this.emitTableElementCount();
          this.doPaging();
          this.orderTableCell("");
          this.doFiltering();
        },
        error: (error) => {
          this.handleHttpError(error);
        },
        complete: () => {
          this.setRefreshEnabled(true);
        },
      });
    },
    selectAgency(agency) {
      this.$emit("onAgencySelected", agency);
    },
    openEditAgency(agency) {
      if (!this.globals.isAccessAllowed("LoopOp_Agencies_Read")) return;
      this.$emit("onAgencyOpenEdit", agency);
    },
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableCell(orderProp) {
      // Nothing to sort by => return
      if (orderProp === "" && this.currentSort.key === "") return;

      if (orderProp !== "") {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }

      const sortFunction = (agency) => {
        if (typeof agency[this.currentSort.key] === "string") {
          return agency[this.currentSort.key].toLowerCase();
        }
        return agency[this.currentSort.key];
      };

      this.filteredAgencies = _.orderBy(
        this.filteredAgencies,
        [sortFunction],
        [this.currentSort.asc ? "asc" : "desc", "asc"]
      );
      this.doPaging();
    },
    doPaging() {
      let startIndex = this.pageNumber * this.pageSize;
      let endIndex = startIndex + this.pageSize;
      this.pagedAgencies = this.filteredAgencies.slice(startIndex, endIndex);
    },
    doFiltering() {
      // Reset filtering when search string is empty
      this.tableFilter === "" || this.tableFilter === undefined
        ? ((this.filteredAgencies = this.allAgencies), this.doPaging())
        : null;

      var words = this.tableFilter.split(" ");
      // Get all keys from agency object
      let keys = [
        "AgencyId",
        "AgencyName",
        "AgencyTypeName",
        "AgencyAddress",
        "AgencyAddress2",
        "AgencyCity",
        "AgencyState_Region",
        "AgencyCountry",
        "AgencyPostalCode",
        "AgencySince",
      ];

      const agencyFilter = (agency) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              agency[key] &&
              agency[key].toString().toLowerCase().indexOf(word.toLowerCase()) >
                -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };

      this.filteredAgencies = this.allAgencies.filter(agencyFilter);
      this.currentSort.asc = !this.currentSort.asc;
      this.orderTableCell(this.currentSort.key);
      this.emitTableElementCount();
    },
    // Emits to parent component
    emitTableElementCount() {
      this.$emit("onTableElementsCountChange", this.filteredAgencies.length);
    },
    setClientTableHeight() {
      var height = $(window).height();
      height -= $(".agency--panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards
      $(".main-table-scrollbar").css("max-height", height);
      $(".table-space").css("max-height", height);

      //Sets top-property for filter, so it doesnt scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    pageSize() {
      this.doPaging();
    },
    pageNumber() {
      this.doPaging();
    },
    tableFilter() {
      this.doFiltering();
    },
  },
};
</script>



// WEBPACK FOOTER //
// AgencyManagementTable.vue?855de4f8